var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"no-permission"},[_c('div'),_c('h3',[_vm._v("当前用户无该操作权限，请联系管理员！")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/login')}}},[_c('a-icon',{attrs:{"type":"left"}}),_vm._v(" 重新登录 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }